// Select component
// Reference: apps/web/src/index.css input styles

import { SelectHTMLAttributes, forwardRef } from 'react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ error, className = '', children, ...props }, ref) => {
    const baseClasses =
      'block w-full rounded-md border px-3 py-2 text-gray-900 focus:ring-1 disabled:bg-gray-100 disabled:cursor-not-allowed appearance-none bg-white bg-no-repeat bg-right';

    const stateClasses = error
      ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
      : 'border-gray-300 focus:border-primary-500 focus:ring-primary-500';

    // Arrow icon using CSS
    const arrowStyle = {
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: 'right 0.5rem center',
      backgroundSize: '1.5em 1.5em',
      paddingRight: '2.5rem',
    };

    return (
      <select
        ref={ref}
        className={`${baseClasses} ${stateClasses} ${className}`}
        style={arrowStyle}
        {...props}
      >
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';

export default Select;
